import Image from 'next/image'

import { Button, WarningLabel } from '@/components'
import { rupiahIcon } from '@/libs/constants/images-library'
import { rewardFormat } from '@/libs/helpers/get-reward-currency'

type TRewardCard = {
  readonly cashBalance: number
  readonly disableWithdraw?: boolean
  readonly onClickWithdraw?: () => void
  readonly withButton?: boolean
  readonly useOwnLoyaltyPlatform?: boolean
  readonly loyaltyPlatform?: {
    loyaltyPlatformIcon: string
    loyaltyPlatformName: string
    loyaltyPlatformPrefix?: string
    loyaltyPlatformSuffix?: string
  }
}

export default function RewardCard({
  cashBalance,
  disableWithdraw,
  onClickWithdraw,
  useOwnLoyaltyPlatform,
  loyaltyPlatform,
  withButton = true,
}: TRewardCard) {
  const { prefix, suffix, reward } = rewardFormat({
    useOwnLoyaltyPlatform,
    loyaltyPlatform,
    rewardType: 'CASH',
    rewardAmount: cashBalance,
    isRewardBalance: true,
  })
  return (
    <figure className='flex flex-col gap-2 rounded-xl bg-white p-3'>
      <div className='flex flex-row items-center justify-between'>
        <div className='flex flex-grow flex-col gap-2'>
          <span className='text-[12px] font-normal'>Rewards</span>
          <div className='sentry-mask flex flex-row items-center gap-2'>
            {useOwnLoyaltyPlatform && loyaltyPlatform?.loyaltyPlatformIcon ? (
              <Image
                src={loyaltyPlatform?.loyaltyPlatformIcon}
                alt={'loyalty-icon'}
                width={18}
                height={18}
              />
            ) : (
              <Image src={rupiahIcon.src} alt={rupiahIcon.alt} width={18} height={18} />
            )}
            <span className='text-xs font-semibold'>
              {prefix}
              {reward}
              {` `}
              {suffix}
            </span>
          </div>
        </div>
        {!useOwnLoyaltyPlatform && withButton && (
          <div className='flex-shrink'>
            <Button
              type='button'
              variant='text'
              color='primary'
              disabledVarian='disabled'
              disabled={disableWithdraw}
              aria-label='Withdraw'
              onClick={onClickWithdraw}
            >
              Withdraw
            </Button>
          </div>
        )}
      </div>
      {useOwnLoyaltyPlatform && <WarningLabel text='Check your balance feature for withdrawal.' />}
    </figure>
  )
}
